<template>
  <div class="absolute z-50 right-3 top-3">
    <!-- TRIGGER -->
    <button
      class="text-primary-contrast hover:opacity-60 transition-opacity"
      @click="toggleDropdown"
    >
      <font-awesome-icon :icon="['fas', 'ellipsis']" />
    </button>

    <!-- DROPDOWN -->
    <Transition name="fade">
      <div
        class="bg-primary-contrast rounded-lg shadow absolute top-7 right-0 z-10 overflow-hidden"
        v-if="dropdownDisplay"
        v-click-outside="closeDropdown"
      >
        <button
          v-for="(item, index) in dropdownItems"
          :key="index"
          class="transition-colors flex px-4 items-center gap-2 hover:bg-primary/10 active:bg-primary text-primary active:text-primary-contrast text-sm w-full h-8 whitespace-nowrap"
          @click="dispatchAction(item.action)"
        >
          <font-awesome-icon :icon="['fas', item.icon]" />
          <span>{{ $t(item.text) }}</span>
        </button>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import useApp from '../../composables/useApp';

const configStore = useConfigStore();

const { refresh } = useApp();

type HomeDropdownItem = {
  icon: string;
  text: string;
  action: () => void;
};

const triggerResizing = () => {
  configStore.setResizing(true);
};

const dropdownDisplay = ref(false);

const dropdownItems: HomeDropdownItem[] = [
  {
    icon: 'rotate',
    text: 'home.dropdown.refresh',
    action: refresh,
  },
  {
    icon: 'power-off',
    text: 'home.dropdown.logout',
    action: configStore.logout,
  },
];

const toggleDropdown = () => {
  dropdownDisplay.value = !dropdownDisplay.value;
};

const closeDropdown = () => {
  dropdownDisplay.value = false;
};

const dispatchAction = (homeDropdownItemAction: HomeDropdownItem['action']) => {
  homeDropdownItemAction();
  closeDropdown();
};
</script>
